import type { YAxisConfig } from 'src/features/forecast/types/YAxisConfig';

export const yAxesConfig: YAxisConfig[] = [
  {
    yAxisId: 'stock',
    orientation: 'left',
    domain: [0, 100],
    axisLine: false,
    tickLine: false,
    tick: {
      fontSize: 12,
      fill: 'var(--chart-text)',
    },
    label: {
      value: 'Stock disponibility',
      angle: -90,
      position: 'insideLeft',
      fill: 'var(--chart-text-secondary)',
      offset: 15,
    },
  },
  {
    yAxisId: 'sales',
    orientation: 'right',
    axisLine: false,
    tickLine: false,
    tick: {
      fontSize: 12,
      fill: 'var(--chart-text)',
    },
    label: {
      value: 'Sales quantity',
      angle: 90,
      position: 'insideRight',
      fill: 'var(--chart-text-secondary)',
      offset: 15,
    },
  },
  {
    yAxisId: 'price',
    orientation: 'right',
    domain: [0, 3],
    axisLine: false,
    tickLine: false,
    tick: {
      fontSize: 12,
      fill: 'var(--chart-text)',
    },
    label: {
      value: 'Price index',
      angle: 90,
      position: 'insideRight',
      fill: 'var(--chart-text-secondary)',
      offset: 15,
    },
  },
];
